/* eslint-disable @typescript-eslint/no-empty-function */
import { NgClass } from '@angular/common';
import {
  Component,
  input,
  forwardRef,
  booleanAttribute,
  model,
  linkedSignal
} from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR
} from '@angular/forms';

import { RadioItemComponent } from '../radio-item/radio-item.component';

export interface RadioButtonItem {
  key: string;
  label: string;
  value: string | number;
}

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'ui-radio',
  standalone: true,
  imports: [FormsModule, NgClass, RadioItemComponent],
  templateUrl: './radio.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioComponent),
      multi: true
    }
  ]
})
export class RadioComponent implements ControlValueAccessor {
  items = input.required<RadioButtonItem[]>();
  orientation = input<'vertical' | 'horizontal'>('vertical');
  variant = input<'radio' | 'check'>('radio');
  disabled = input(false, { transform: booleanAttribute });

  isDisabled = linkedSignal(() => this.disabled());

  selectedValue = model<string | number>();

  private onChange: (value: string | number) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: string | number): void {
    this.selectedValue.set(value);
  }

  registerOnChange(fn: (value: string | number) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled.set(isDisabled);
  }

  handleValueChange(newValue: string | number): void {
    this.selectedValue.set(newValue);
    this.onChange(newValue);
    this.onTouched();
  }
}
